import React from 'react';
import ReactModal from 'react-modal';

const customStyles = {
  content: {
    maxWidth: '750px',
    margin: '100px auto 20px',
    bottom: 'auto',
  },
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
ReactModal.setAppElement('#root');

const Modal = ({
  children,
  isOpen,
  onRequestClose,
  title,
  subtitle,
  ...others
}) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    style={customStyles}
    contentLabel="Modal"
    closeTimeoutMS={300}
    shouldCloseOnOverlayClick={false}
    {...others}
  >
    <h2 className="c-heading--alpha">
      {title}
      <button
        className="c-btn c-btn--dark-cross"
        style={{ float: 'right', marginLeft: '10px' }}
        onClick={onRequestClose}
      />
    </h2>
    <p className="u-weight-light u-margin-bottom-none">{subtitle}</p>
    <div className="u-margin-top-huge">{children}</div>
  </ReactModal>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/common/Modal.js